export default {
  addItem: {
    margin: 10,
  },
  addItemContainer: {
    textAlign: 'right',
  },
  body: {
    padding: 10,
  },
  stageIcon: {
    height: 50,
    width: 50,
  },
  iconCol: {
    width: 80,
  },
  nameCol: {},
  typeCol: {
    width: 120,
  },
  qualityControlCol: {
    width: 120,
  },
  actionCol: {
    width: 120,
  }
};



// WEBPACK FOOTER //
// ./src/components/JobProfile/styles.js